module.exports = __webpack_public_path__ + "static/media/icons_Bilan Epicondylalgie.ef3056b7.svg";